import ModuleTabs from '@/components/common/ModuleTab';
import LimitOrderForm from '@/components/form/LimitOrderForm';
import MarketOrderForm from '@/components/form/MarketOrderForm';
import OcoOrderForm from '@/components/form/OcoOrderForm';
import StopOrderForm from '@/components/form/StopOrderForm';
import { useAppSelector } from '@/state/hooks';
import { PairMap } from '@/state/reducers/marketPairSlice';
import { selectOrderModalPrefillValues } from '@/state/reducers/orderSlice';
import useLanguage from '@/utils/hooks/useLanguage';
import useOrderExecution from '@/utils/hooks/useOrderExecution';
import { useDebouncedSize } from '@/utils/hooks/useSize';
import { Tab } from '@headlessui/react';
import { useMemo, useRef } from 'react';

interface OrderExecutionProps {
    instrument: PairMap;
}

export default function OrderExecution(props: OrderExecutionProps) {
    const { instrument } = props;

    const orderBodyRef = useRef<HTMLDivElement>(null);
    const size = useDebouncedSize(orderBodyRef);

    const lang = useLanguage();

    const orderPrefillValues = useAppSelector(selectOrderModalPrefillValues);
    const orderExecutionProps = useOrderExecution('spot', instrument);

    // const prefillValues = useMemo(() => {
    //     if (instrument?.celer === orderPrefillValues?.instrument?.celer) return orderPrefillValues;
    //     return undefined;
    // }, [instrument, orderPrefillValues]);

    const tabs = useMemo(() => {
        return [
            lang.orderForm.marketOrder,
            lang.orderForm.limitOrder,
            lang.orderForm.stopOrder,
            lang.orderForm.ocoOrder
        ];
    }, [lang]);

    return (
        <div ref={orderBodyRef} className="flex flex-col h-full" dir={lang.dir}>
            <Tab.Group>
                <ModuleTabs.Main tabs={tabs} />
                <Tab.Panel className="flex-1 overflow-y-auto">
                    <MarketOrderForm
                        parentSize={size?.width}
                        {...orderExecutionProps}
                        // prefillValues={prefillValues}
                    />
                </Tab.Panel>
                <Tab.Panel className="flex-1 overflow-y-auto">
                    <LimitOrderForm
                        parentSize={size?.width}
                        {...orderExecutionProps}
                        // prefillValues={prefillValues}
                    />
                </Tab.Panel>
                <Tab.Panel className="flex-1 overflow-y-auto">
                    <StopOrderForm
                        parentSize={size?.width}
                        {...orderExecutionProps}
                        // prefillValues={prefillValues}
                    />
                </Tab.Panel>
                <Tab.Panel className="flex-1 overflow-y-auto">
                    <OcoOrderForm
                        parentSize={size?.width}
                        {...orderExecutionProps}
                        // prefillValues={prefillValues}
                    />
                </Tab.Panel>
            </Tab.Group>
        </div>
    );
}
